<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cent">
      <div class="cent_1">
        <div class="cent_top">
          <div class="cent_top_content">
            <img src="../../assets/img/dingdan/pay_icon_order.png" alt />
            <p>订单号：{{orderinfo.order_sn}}</p>
          </div>
        </div>
        <div class="cent_bottom">
          <div class="cent_bottom_1">
            <ul>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step01_sel.png" alt />
                <p>沟通需求</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step02_nor.png" alt />
                <p>下单预付</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step03_nor.png" alt />
                <p>为您服务</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step04_nor.png" alt />
                <p>验收服务</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_1">
        <div class="content_top">
          <div class="content_top_left">
            <div class="content_top_p1">
              <p>
                <span style="color:#FF4D43FF">*</span>我需要：
              </p>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                class="input1"
                v-model="orderinfo.service_name"
              ></el-input>
            </div>
            <div class="content_top_p1">
              <p>
                <span style="color:#FF4D43FF">*</span>补充需求:
              </p>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="详细完整的需求有助于我们更好的为您服务（非必填）"
                class="input1"
                v-model="from.input"
              ></el-input>
            </div>
            <div class="content_top_p1">
              <p>
                <span style="color:#FF4D43FF">*</span>金额：
              </p>
              <el-input class="input2" placeholder="请输入内容" v-model="orderinfo.goods_price"></el-input>
            </div>
            <div class="content_top_p1">
              <p>
                <span style="color:#FF4D43FF">*</span>服务开始时间：
              </p>
              <el-date-picker v-model="orderinfo.create_time" type="date" placeholder="选择日期"></el-date-picker>
            </div>
          </div>
          <div class="content_top_right">
            <div class="content_top_right1">
              <div class="content_top_rightimg">
                <img :src="orderinfo.avatar" alt />
              </div>
              <p>{{orderinfo.providers_name}}</p>
            </div>
            <div class="content_top_right2">
              <div class="right_img">
                <img src="../../assets/img/fuwuxiang/fws_icon_tel.png" alt />
                <p>{{orderinfo.phone}}</p>
              </div>
              <div class="right_img">
                <img src="../../assets/img/fuwuxiang/fws_icon_location.png" alt />
                <p>天津市河西区陈塘庄尊化商务中心205室</p>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div class="content_cent">
          <div class="content_cent_1">
            <el-button type="primary" class="button" @click="zhifu()">立即支付</el-button>
          </div>
        </div>
        <div class="content_botom">
          <div class="content_botom_1">
            <el-button
              type="primary"
              class="bot"
              @click="agreement()"
              v-if="orderinfo.contract_status == 1"
            >发起合同</el-button>
            <el-button
              type="primary"
              class="bot"
              @click="agreement()"
              v-else-if="orderinfo.contract_status == 2"
            >查看合同</el-button>
            <el-button type="primary" class="bot" @click="agreement()" v-else>查看合同</el-button>
            <el-button type="primary" class="bot" @click="del()">关闭需求</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { createOrder, OrderInfo, delOrder, createOrderReply } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      orderx: [],
      from: {
        input: ""
      },
      orderinfo: []
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    zhifu(from,orderinfo) {
      var id = this.$route.query.id;
      this.token = localStorage.getItem("token");
      // createOrderReply({
      //   token: this.token,
      //   order_id: id,
      //   remark_member: this.from.input
      // }).then(res => {
        this.$router.push({
          name: "yufu",
          query: {
            order_id: this.orderinfo.order_sn,
            order_price: this.orderinfo.goods_price,
            goods_id: this.orderinfo.id,
            provider_id: this.orderinfo.provider_id,
            remark_member:this.from.input
          }
        });
      // });
    },
    // createorder(price, id, provider_id) {
    //   this.token = localStorage.getItem("token");
    //   createOrder({
    //     token: this.token,
    //     goods_price: price,
    //     goods_id: id,
    //     provider_id: provider_id,
    //     is_demand: 1,
    //     demand_title: "",
    //     remark_member: this.from.input
    //   }).then(res => {
    //     this.orderx = res.data.data;
    //   });
    // },
    agreement() {
      this.$router.push({
        name: "faqihetong",
        query: {
          goods_id: this.orderinfo.id,
          goods_price: this.orderinfo.goods_price,
          service_name: this.orderinfo.service_name
        }
      });
    },
    orderInfo(id) {
      this.token = localStorage.getItem("token");
      OrderInfo({
        token: this.token,
        order_id: id
      }).then(res => {
        this.orderinfo = res.data.data;
      });
    },
    del(id) {
      this.token = localStorage.getItem("token");
      delOrder({
        token: this.token,
        order_id: id
      }).then(res => {
        if (res.data.errcode == 200) {
          this.$router.go(-1);
        }
      });
    }
  },
  created() {
    var id = this.$route.query.id;
    this.orderInfo(id);
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.cent {
  width: 100%;
  background: #007bff;
}

.cent_1 {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
}

.cent_top {
  width: 100%;
  height: 100px;
  overflow: hidden;
}

.cent_top_content {
  width: 300px;
  height: 62px;
  margin: 20px auto;
}

.cent_top_content img {
  float: left;
  padding: 8px 0;
}

.cent_top_content p {
  line-height: 60px;
  color: #ffffff;
}

.cent_bottom {
  width: 100%;
  height: 100px;
  background: #f4f5f9;
  overflow: hidden;
}

.cent_bottom_1 {
  width: 500px;
  height: 66px;
  margin: 18px auto;
}

.cent_bottom_1 ul li {
  float: left;
  padding: 0 15px;
}

.cent_bottom_1 ul li p {
  font-size: 12px;
  font-weight: 400;
}

.cent_bottom_1 ul li i {
  line-height: 66px;
  font-weight: 600;
}

.content {
  width: 100%;
  height: 686px;
  background: #f4f5f9;
}

.content_1 {
  width: 1200px;
  height: 540px;
  background: #fff;
  margin: 0 auto;
}

.content_top {
  width: 100%;
  height: 430px;
}

.content_cent {
  width: 100%;
  height: 65px;
}

.content_top_left {
  width: 630px;
  height: 310px;
  float: left;
  margin: 40px 0 0 79px;
}

.content_top_right {
  width: 350px;
  height: 187px;
  border: 1px solid #e4e4e4;
  float: right;
  margin: 40px 90px 0 0;
}

.content_top_right1 {
  width: 100%;
  height: 88px;
  background: #f4f5f9;
}

.content_top_rightimg {
  width: 48px;
  height: 48px;
  float: left;
  margin: 20px 0 0 20px;
}

.content_top_rightimg img {
  width: 48px;
  height: 48px;
}

.content_top_right1 p {
  font-size: 14px;
  font-weight: bold;
  float: left;
  line-height: 74px;
  margin-left: 10px;
}

.content_top_right2 {
  width: 200px;
  height: 50px;
  margin: 0 auto;
}
.right_img {
  width: 300px;
  height: 20px;
  margin-top: 15px;
}

.right_img img {
  float: left;
}

.right_img p {
  width: 224px;
  height: 30px;
  font-size: 14px;
  margin-left: 5px;
  float: left;
}

.content_botom {
  width: 100%;
  height: 60px;
  border-top: 1px solid #f4f5f9ff;
}

.content_top_p1 {
  width: 100%;
  height: 71px;
  line-height: 60px;
  color: #666666ff;
  font-size: 14px;
  margin: 24px 0 0 0;
}

.content_top_p1 p {
  width: 110px;
  float: left;
  text-align: right;
  padding: 0 20px 0 0;
}

.input1 {
  width: 480px;
  height: 76px;
  float: left;
}

.input2 {
  width: 230px;
  height: 36px;
  float: left;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.content_botom_1 {
  float: right;
  margin-right: 40px;
}

.bot {
  width: 100px;
  height: 30px;
  background: #f4f5f9;
  outline: 0;
  border: 0;
  color: #222222;
  font-size: 12px;
  margin: 8px 0 0 0;
}

.bot:hover {
  background: #007bff;
  color: #fff;
}

.content_cent_1 {
  width: 180px;
  height: 44px;
  margin: 0 auto;
}

.button {
  width: 180px;
  height: 44px;
  background: #f7681eff;
  outline: 0;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Dingdan/Dingdan.vue